document.addEventListener('DOMContentLoaded', function () {
  const submittedFormId = sessionStorage.getItem('submittedFormId');
  document.querySelectorAll('[data-form-messages]').forEach(function (el) {
    if (el.dataset.formMessages !== submittedFormId) {
      el.style.display = 'none';
    }
  });

  sessionStorage.removeItem('submittedFormId');
});

document.querySelectorAll('form[data-form-id]').forEach(function (form) {
  form.addEventListener('submit', function () {
    sessionStorage.setItem('submittedFormId', form.dataset.formId);
  });
});